import { memo, useCallback, useMemo } from 'react';
import RewardsSection from '../RewardsSection/RewardsSection';
import { PendingRewardsSectionProps } from './PendingRewardsSection.types';
import PendingRewardCard from '../PendingRewardCard/PendingRewardCard';
import {
  List,
  ListProps,
  Skeleton,
  useBreakpointProp,
  VerticalListSeparator,
} from '@bonanza-social/moonlight';
import { ListRenderItem } from 'react-native';
import usePendingRewards from '../../hooks/usePendingRewards';
import { PendingReward } from '../../shared/pendingRewards.types';
import FreeSpinsEmpty from '../FreeSpinsSection/FreeSpinsEmpty';

function PendingRewardsSection({ itemWidth }: PendingRewardsSectionProps) {
  const { pendingRewards, pendingRewardsLoading } = usePendingRewards();

  const numColumns = useBreakpointProp({
    mobile: 1,
    tablet: 2,
    desktop: 3,
  });

  const renderItem = useCallback<ListRenderItem<PendingReward>>(
    ({ item }) => (
      <PendingRewardCard itemWidth={itemWidth} pendingReward={item} />
    ),
    [itemWidth],
  );

  const columnWrapperStyle = useMemo(
    (): ListProps['columnWrapperStyle'] =>
      numColumns > 1 ? { gap: 'space-400' } : undefined,
    [numColumns],
  );

  if (pendingRewardsLoading) {
    return <Skeleton height={148} />;
  }

  return (
    <RewardsSection
      titleLocKey={
        pendingRewards.length > 0 ? 'pendingRewardsTitle' : 'rewards'
      }
    >
      <List
        key={numColumns}
        data={pendingRewards}
        renderItem={renderItem}
        ItemSeparatorComponent={VerticalListSeparator}
        numColumns={numColumns}
        columnWrapperStyle={columnWrapperStyle}
        ListEmptyComponent={<FreeSpinsEmpty />}
        scrollEnabled={false}
      />
    </RewardsSection>
  );
}
export default memo(PendingRewardsSection);
